import { Path, StyleSheet, Svg } from '@react-pdf/renderer';
import { Style } from '@react-pdf/types';
import defaultTheme from 'theme/defaultTheme';

const styles = StyleSheet.create({
    slant: {
        width: '100%',
        transform: 'rotate(180deg)',
    },
});

export const Slant = ({ color = defaultTheme.colors.fill, style }: { color?: string; style?: Style }) => {
    const slantStyles: Style[] = [styles.slant];
    if (style) slantStyles.push(style);

    return (
        <Svg viewBox="0 0 1200 60" preserveAspectRatio="none" style={slantStyles}>
            <Path d="M1200 60L0 16.48 0 0 1200 0 1200 60z" fill={color} />
        </Svg>
    );
};
